module.exports = __webpack_public_path__ + "static/media/dutch_icon_store.d99a289a.png";